<template>
  <b-modal id="createAgreementModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.excmagreement.createAgreementHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <EXCMAgreementCreate :openedInModal="true"></EXCMAgreementCreate>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import EXCMAgreementCreate from '../Create.vue'
export default {
  name: 'CreateAgreementModal',
  components: {
    EXCMAgreementCreate
  },
  computed: {
    show () {
      return this.$store.state.modals.excmagreement.create.show
    },
    close () {
      return this.$store.state.modals.excmagreement.create.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      action: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1) {
        this.$store.state.modals.excmagreement.create.show = 0
        this.$bvModal.show('createAgreementModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.excmagreement.create.close = 0
        this.$bvModal.hide('createAgreementModal')
      }
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
